import React, { useEffect, useState } from 'react';
import './CSS/ResultadosExames.css';
import clinicaConfig from "../clinicaConfig.js";
import localChaveSenha from '../Components/Assets/localdachavesenha.png';

const ResultadosExames = () => {
  const [countdown, setCountdown] = useState(6);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          window.open('https://portal.worklabweb.com.br/resultados-on-line/1597', '_blank');
          window.location.href = '/';
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="resultados-redirect-page">
      <div className="redirect-container">
        <div className="redirect-logo">
          <img src={clinicaConfig.logo} alt={clinicaConfig.nomeClinica} />
        </div>
        
        <div className="loading-spinner">
          <div className="spinner"></div>
        </div>

        <h1>Redirecionando para o Portal de Resultados</h1>
        
        <div className="redirect-info">
          <p className="redirect-message">
            Você será direcionado em <strong>{countdown}</strong> segundo{countdown !== 1 ? 's' : ''}...
          </p>
          
          <div className="info-box">
            <h3>📋 Importante</h3>
            <p>
              No portal, você deverá inserir a <strong>chave e senha</strong> que 
              recebeu no comprovante quando realizou o exame.
            </p>
            <div className="comprovante-exemplo">
              <img src={localChaveSenha} alt="Local da chave e senha no comprovante" />
              <p className="legenda">Localize a chave e senha no rodapé do seu comprovante</p>
            </div>
          </div>

          <p className="manual-redirect">
            Caso não seja redirecionado automaticamente, 
            <a 
              href="https://portal.worklabweb.com.br/resultados-on-line/1597"
              target="_blank"
              rel="noreferrer"
            >
              clique aqui
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ResultadosExames;
